import React from 'react';
import { useSelector } from 'react-redux';
import { Spinner } from '@guryou/html-components';
import { stateIsLoading, stateIsNotInitialized } from '@guryou/redux';
import WidgetVideoDetails from './WidgetVideoDetails';

const WidgetVideos = () => {
  const videos = useSelector(state => state.widget.videos);

  if (stateIsNotInitialized(videos)) {
    return null;
  }
  if (stateIsLoading(videos)) {
    return <Spinner />;
  }

  return (
    <div class="grid gap-4 sm:grid-cols-2 md:gap-6 lg:grid-cols-3 xl:grid-cols-4 xl:gap-8">
      {videos.data.map((video, idx) => (
        <WidgetVideoDetails key={`video_${idx}`} video={video} />
      ))}
    </div>
  );
};

export default WidgetVideos;
